import React, { useState, useEffect } from 'react';
import { Box, Grid, useMediaQuery, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import UploadSection from './UploadSection';
import VideoComponent from './VideoPlayer';
import { getModelName, uploadFile, generateSearchVideo, getUploadedImages,  } from '../../services/apiService';
import { showToast } from '../Toast/CommonToast';
import LoaderWithBackdrop from '../Loader/loader';

function Reels() {
  const location = useLocation();
  const isReelsPage = location.pathname.startsWith('/studio/reels');
  const isMobile = useMediaQuery('(max-width:600px)');
  const [image, setImage] = useState<string | null>(null);
  const [eventIdRes, setEventIdRes] = useState<string>('');
    const [quotes, setQuotes] = useState<string>('');
  const [ duration, setDuration ] = useState<string>('6');
  const [loading, setLoading] = useState<boolean>(false);
  const [uploadFiles, setUploadFile] = useState<any>(null);
  const [prompt, setPrompt] = useState<string>('');
  const [dragImage, setDragImage] = useState<string | null>(null);
  const userId = localStorage.getItem("userId") || "";
  const [uploadExistingImages, setUploadExistingImages] = useState<any>([]);
const [allSearchImages, setAllSearchImages] = useState<any[]>([]);
  const [selectedImageId, setSelectedImageId] = useState<any | null>([{
    _id: '',
    url: '',
    caption: ''
  }]);
  const [videoData, setVideoData] = useState<any[]>([]);
  // Removed unused selectedAnimation state
  const animationLocation = location.pathname.includes("studio/reels") ? "studio/reels" : undefined;
  const [sharePopup, setSharePopup] = React.useState(false);
  const [scheduledData, setScheduledData] = useState<any[] | null>(null);


  useEffect(() => {
    fetchModelName();
  }, [])


  // Modelname geti
  const fetchModelName = async () => {
    try {
      const response = await getModelName("video");
      console.log("Model Name Response:", response);
      if (response.status === "success") {
        setEventIdRes(response.data);
      }
    } catch (error) {
      console.error("Error fetching model name", error);
    }
  }

  const eventId = Array.isArray(eventIdRes) ? eventIdRes.find((item: any) => item.eventName === "Reels")?._id : '68590b5ec4e2a96de6be37dc';
  localStorage.setItem("audioEventId", eventId);
  const rampEventID = Array.isArray(eventIdRes) ? eventIdRes.find((item: any) => item.eventName === "Ramp Walk")?._id : "685e428e94e0f8921c36a887";
  localStorage.setItem("rampEventID", rampEventID)

  // Determine which eventId to use based on the route
  const activeEventId = location.pathname.includes("studio/reels") ? eventId : rampEventID;



  // existing images
  const handleallfetchimages = React.useCallback(async (eventIdToUse: string) => {
    try {
      const payLoadSearch = {
        eventId: eventIdToUse,
        userId: userId
      }
      const response = await generateSearchVideo(payLoadSearch);
      if (response.status === "success") {
        setAllSearchImages(response.data);
        setScheduledData(response?.scheduledYouTubeUpdates );
      }
    } catch (error) {
      console.error("Error fetching video:", error);
    }
  }, [userId]);

  useEffect(() => {
    handleallfetchimages(activeEventId);
  }, [activeEventId, handleallfetchimages, sharePopup])

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (files) {
      const formData = new FormData();

      Array.from(files).forEach((file, index) => {
        formData.append("files", file);
      });
      formData.append("userId", userId);
      formData.append("isStudioImage", "true");
      formData.append("eventId", activeEventId);
      setLoading(true);
      try {
        const uploadFileResponse = await uploadFile(formData);
        setLoading(false);

        if (uploadFileResponse.status === "success") {
          showToast(uploadFileResponse.message, "success");
          setUploadFile?.(uploadFileResponse.data[0]);
          setPrompt?.(uploadFileResponse.data[0].videoPrompt || '');
          setImage?.(uploadFileResponse.data[0].url);
        }else{
          showToast(uploadFileResponse.message, "error");
        }

      } catch (error: any) {
        showToast(error.message, "error");
        setLoading(false);
        console.error("Error uploading files", error);
      }
    }
  };

  const fetchExistingImages = React.useCallback(async () => {
    if (!userId || !activeEventId) return;
    try {
      const response = await getUploadedImages(userId, activeEventId);
      if(response){
        setUploadExistingImages(response);
      }
    } catch (error) {
      console.error("Error fetching video:", error);
    }
  }, [userId, activeEventId]);

  useEffect(() => {
    if (activeEventId) {
      fetchExistingImages();
    }
  }, [userId, uploadFiles, activeEventId, fetchExistingImages])

  const handleRemove= () =>{
    setImage(null);
    setPrompt('');
    setUploadFile(null);
    setDragImage(null);
    setSelectedImageId(null);
    setQuotes('');
    setDuration('6'); 
  }


  

  return (
    <Box className="flex-scroll-area 
flex-scroll-area">
      {loading && <LoaderWithBackdrop open={loading} />}
      <Box>
           <Typography variant="h1" className='productHeading' gutterBottom>
                {isReelsPage ? "Reels" : "Ramp Walk"}
            </Typography>
      </Box>
      <Grid container spacing={2} direction={isMobile ? 'column' : 'row'} >
        <Grid item xs={12} md={6} lg={5}>
          <UploadSection handleFileUpload={handleFileUpload}  image={image} uploadExistingImages={uploadExistingImages} 
          setDragImage={setDragImage} dragImage={dragImage}
          handleRemove={handleRemove}
          setSelectedImageId={setSelectedImageId} selectedImageId={selectedImageId}
          setPrompt={setPrompt} prompt={prompt} 
          eventId={activeEventId}
          setVideoData={setVideoData}
          setImage={setImage} setUploadFile={setUploadFile}
          setQuotes={setQuotes} quotes={quotes}
          setDuration={setDuration} duration={duration}
          eventIdRes={eventIdRes}
          animationLocation={!!animationLocation}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={7} >
          <VideoComponent
            image={image}
            setImage={setImage}
            prompt={prompt}
            setPrompt={setPrompt}
            videoData={videoData}
            setAllSearchImages={setAllSearchImages}
            allSearchImages={allSearchImages}
            animationLocation={animationLocation}
            sharePopup={sharePopup}
            setSharePopup={setSharePopup}
            setScheduledData={setScheduledData}
            scheduledData={scheduledData}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Reels;